// The columns each product read asks for (data.js), in 1 place, so the tests replay exactly these
// (tests/e2e/fixtures/product/record-product.sql reads the same, and product.spec.js refuses any other).
// Pure: no imports.
export const PRODUCT_COLUMNS = 'id, slug, path, name, type, look, access_kind, state, moved_in, settings, '
  + 'questions_email, live_sessions_audience, release_basis, join_opens_minutes, watched_share, '
  + 'certificate_on, certificate_rule, min_access_months, min_access_from, terms_line'
export const COHORT_COLUMNS = 'id, product_id, name, kind, schedule_label, starts_on, ends_on, weeks_total, number'
export const MODULE_COLUMNS = 'id, product_id, key, number, label, title, teaser, homework_note, sort_order, is_published'
export const SESSION_COLUMNS = 'id, product_id, cohort_id, module_id, number, title, starts_at, duration_minutes, status, zoom_join_url'
// thumbnail_path: Adam's own 16:9 thumbnail for the recording's cards (decision 47, 12 Oct; migration
// 20261012200000), signed by sign-file's recordings target only when 1 is set
export const RECORDING_COLUMNS = 'id, product_id, module_id, session_id, key, part, title, recorded_on, sort_order, is_published, published_at, thumbnail_path'
// the light read: enough for lists, search and lengths; a recording page reads the rest
export const CONTENT_LIGHT = 'recording_id, duration_seconds, chapters'
export const CONTENT_FULL = 'recording_id, vimeo_url, vimeo_id, vimeo_hash, duration_seconds, chapters, summary, key_messages, key_learnings'
export const PROGRESS_COLUMNS = 'recording_id, position_seconds, furthest_seconds, seconds_watched, watched_at, last_played_at'
export const HOMEWORK_COLUMNS = 'id, product_id, module_id, recording_id, group_heading, time_label, body, kind, sort_order, removed_at'
export const SECTION_COLUMNS = 'id, product_id, name, sort_order, tab_note'
export const PLACEMENT_COLUMNS = 'id, item_id, product_id, section_id, module_id, recording_id, sort_order, title_override, '
  + 'subline_override, release_kind, release_module_id, release_session_id, release_at, yours_for_life, new_until, removed_at, created_at'
export const ITEM_COLUMNS = 'id, kind, title, subline'
export const BODY_COLUMNS = 'item_id, link_url, text_body, vimeo_url'
export const CHECKLIST_COLUMNS = 'id, product_id, sort_order, body, action_kind, action_label, action_target'
export const STATE_COLUMNS = 'product_id, last_opened_at, welcome_hidden_at, offer_reached_at, offer_reached_how, finished_at'
export const CERTIFICATE_COLUMNS = 'id, number, check_path, product_id, cohort_id, name_on_certificate, course_name, cohort_label, '
  + 'period_from, period_to, completed_on'
export const STEP_COLUMNS = 'id, product_id, section, step_key, step_type, title, body_md, config, module_id, recording_id, sort_order, is_published'

// A mastermind's recordings are its groups' and carry tags (Accelerator.dc.html's Recordings: the
// group, the date tile, the tags and the topic chips; docs/data-model.md 10.6.1), so its product
// read asks for each recording's group and the tags on what has been released to them, and its
// group's WhatsApp link. Profit On Your Terms's asks for each week's pack line (POYT.dc.html's
// "Pack: ..."), Start here's screens under their 2 rows and each member's answers (10.6.2), and
// whether their intake has the deal surgery. Every other product keeps the reads above, column for
// column.
export const RECORDING_COLUMNS_GROUPED = `${RECORDING_COLUMNS}, cohort_id`
export const CONTENT_TAGGED = `${CONTENT_LIGHT}, tags`
// The group's own WhatsApp link (hub.cohort_links: only the member's own open group's row comes back)
export const COHORT_LINK_COLUMNS = 'cohort_id, whatsapp_invite_url'
export const STEP_PROGRESS_COLUMNS = 'step_id, position_seconds, done_at'
export const MODULE_COLUMNS_PACKED = `${MODULE_COLUMNS}, pack_line`
export const STEP_COLUMNS_SCREENS = `${STEP_COLUMNS}, parent_step_id`
export const STEP_PROGRESS_ANSWERS = `${STEP_PROGRESS_COLUMNS}, answers, updated_at`
export const COHORT_COLUMNS_SURGERY = `${COHORT_COLUMNS}, deal_surgery`

// The selects 1 product's read sends: columnsFor({ type, slug }) (a type alone still works)
export function columnsFor(product) {
  const { type = null, slug = null } = typeof product === 'string' ? { type: product } : (product || {})
  const grouped = type === 'mastermind'
  const poyt = slug === 'poyt'
  return {
    recordings: grouped ? RECORDING_COLUMNS_GROUPED : RECORDING_COLUMNS,
    contentLight: grouped ? CONTENT_TAGGED : CONTENT_LIGHT,
    cohortLinks: grouped,
    modules: poyt ? MODULE_COLUMNS_PACKED : MODULE_COLUMNS,
    steps: poyt ? STEP_COLUMNS_SCREENS : STEP_COLUMNS,
    stepProgress: poyt ? STEP_PROGRESS_ANSWERS : STEP_PROGRESS_COLUMNS,
    cohorts: poyt ? COHORT_COLUMNS_SURGERY : COHORT_COLUMNS,
  }
}
